import {
  calculateAppOrderSubtotal,
  checkout,
  removeFromCart,
} from 'features/cart/CartSlice';
import { useEffect } from 'react';
import useThunkDispatch from '../../common/hooks/useThunkDispatch';
import useTypedSelector from '../../common/hooks/useTypedSelector';
import CartPresenter from './CartPresenter';

function Cart() {
  const { groupRefKeys, apps, registrations, orderSubtotal, fetchStatus } =
    useTypedSelector((state) => ({
      groupRefKeys: state.cart.groupRefKeys,
      apps: state.applications.entities,
      registrations: state.registeredApps.entities,
      orderSubtotal: state.cart.orderSubtotal,
      fetchStatus: state.cart.meta.fetchStatus,
    }));

  const dispatch = useThunkDispatch();

  useEffect(() => {
    dispatch(calculateAppOrderSubtotal());
  }, [orderSubtotal, dispatch]);

  const cartItems = [];

  // New applications
  for (const app of Object.values(apps)) {
    if (!groupRefKeys.includes(app.groupRefKey)) continue;
    const ci = {
      appId: app.id,
      groupRefKey: app.groupRefKey,
      referenceNum: app.groupRefKey,
      address: app.address,
      price: app.price,
      renewal: false,
    };
    cartItems.push(ci);
  }

  // Registered applications that are valid for renewal
  for (const registration of Object.values(registrations)) {
    if (!groupRefKeys.includes(registration.groupRefKey)) continue;

    const ci = {
      appId: registration.appId,
      groupRefKey: registration.groupRefKey,
      referenceNum: registration.groupRefKey,
      address: registration.address,
      price: registration.renewalPrice,
      renewal: true,
    };
    cartItems.push(ci);
  }

  return (
    <CartPresenter
      cartItems={cartItems}
      orderSubtotal={orderSubtotal}
      removeFromCart={(id) => dispatch(removeFromCart(id))}
      checkout={() => dispatch(checkout())}
      checkoutLoading={fetchStatus}
    />
  );
}

export default Cart;
